<template>
  <svg
   xmlns="http://www.w3.org/2000/svg"
   id="svg8"
   version="1.1"
   viewBox="0 0 15.875 4.2333335"
   height="16"
   width="60"
   :x="x"
   :y="y">
  <g
     transform="translate(0,-292.76665)"
     id="layer1">
    <rect
       y="292.7005"
       x="-0.047247026"
       height="4.2333331"
       width="15.875"
       id="rect1015"
       style="opacity:1;fill:#ffffff;" />
    <path
       id="path815"
       d="m 1.0866815,293.30526 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6"
       d="m 1.0866815,293.30526 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4"
       d="m 1.889881,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4"
       d="m 2.4190477,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-8"
       d="m 3.4773811,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2"
       d="m 4.0065478,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7"
       d="m 5.5940479,295.40776 v -2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7-7"
       d="m 6.1232146,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7-7-1"
       d="m 6.6523813,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7-7-1-8"
       d="m 7.7107147,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7-7-1-8-2"
       d="m 8.7690481,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7-7-1-8-2-6"
       d="m 9.2982148,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7-7-1-8-2-6-7"
       d="m 9.8273815,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="path815-6-4-4-2-7-7-1-8-2-6-8"
       d="m 10.356548,293.28164 v 2.12612"
       style="fill:none;stroke:#b3b3b3;stroke-width:0.32404709px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <text
       id="text1011"
       y="296.71649"
       x="0.9921875"
       style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:condensed;font-size:1.41111112px;line-height:1.25;letter-spacing:0px;word-spacing:0px;fill:#999999;fill-opacity:1;font-family:Arial;"><tspan
         style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;letter-spacing:0.15081251px;fill:#999999"
         y="296.71649"
         x="0.9921875"
         id="tspan1009">1901123456</tspan></text>
    <path
       transform="rotate(-136.72983,13.491577,295.29362)"
       d="m 13.93785,295.36572 c -0.07436,0.0178 -0.0611,-0.0905 -0.02937,-0.12267 0.08338,-0.0846 0.219336,-0.0225 0.271342,0.0647 0.09203,0.15445 -0.0044,0.34672 -0.155762,0.41796 -0.220411,0.10379 -0.475163,-0.0307 -0.56348,-0.24574 -0.117051,-0.28496 0.05658,-0.60366 0.335057,-0.70821 0.348848,-0.13098 0.731984,0.0822 0.852346,0.42389 0.145223,0.41234 -0.107527,0.86006 -0.512361,0.99598 -0.475528,0.15965 -0.987868,-0.13276 -1.139175,-0.60052 -0.174191,-0.5385 0.157878,-1.11543 0.688409,-1.28201 0.601289,-0.18879 1.242762,0.18291 1.424517,0.77608 0.203435,0.66392 -0.207852,1.36986 -0.863537,1.56673 -0.726419,0.2181 -1.496771,-0.23273 -1.708688,-0.95082 -0.0086,-0.029 -0.01621,-0.0583 -0.02293,-0.0878"
       id="path1013"
       style="fill:none;fill-rule:evenodd;stroke:#b3b3b3;stroke-width:0.34662461" />
  </g>
</svg>
</template>
<script>
export default {
  props: {
    x: Number,
    y: Number,
    height: Number,
    width: Number
  }
}
</script>